import { AppSettingsModule } from 'services/settings.provider';
import { OnboardingServiceModule } from 'services/data/onboarding.service';
import { FounderGuideServiceModule } from 'services/utilities/founderGuide.service';
import { DataServiceModule } from './data.service';

export const StoreInformationServiceModule = angular
    .module('app.services.data.storeInformation', [
        DataServiceModule,
        AppSettingsModule,
        OnboardingServiceModule,
        FounderGuideServiceModule
    ]).service('storeInformationService', (
        $q,
        $http,
        onboardingService,
        founderGuideService,
        dataService,
        settings
    ) => {
        let store = null;
        let storeCall = null;

        return {
            checkEmail,
            getCustomDomainStatus,
            getLaunchStatus,
            getStore,
            hasStoreAddress,
            registerCustomDomain,
            removeCustomDomain,
            removeImage,
            save
        };

        function getStore(force) {
            if (store && !force) {
                return $q.resolve(store);
            } else if (storeCall) {
                return storeCall;
            }

            storeCall = dataService.get(settings.api.storeInformation).then((response) => {
                store = response;
                storeCall = null;
                return response;
            });

            return storeCall;
        }

        function getCustomDomainStatus() {
            return dataService.get(settings.api.customDomainStatus);
        }

        function registerCustomDomain(domain) {
            return dataService.create(settings.api.registerCustomDomain, { domain });
        }

        function hasStoreAddress() {
            return getStore().then((response) => {
                return angular.isDefined(response.mailingAddress)
                    && isValidAddressString(response.mailingAddress.address1)
                    && isValidAddressString(response.mailingAddress.city)
                    && isValidAddressString(response.mailingAddress.state)
                    && isValidAddressString(response.mailingAddress.postalCode);
            });
        }

        function isValidAddressString(s) {
            return angular.isDefined(s) && s !== '';
        }

        function checkEmail(email) {
            return $http.get(`${process.env.BASE_API_URL}/users`, {
                params: {
                    email: email
                }
            }).then(res => res.data);
        }

        function removeCustomDomain(customDomain) {
            const apiUrl = `${process.env.BASE_API_URL}/${settings.api.storeInformationCustomDomain}`;
            return $http.delete(apiUrl, {
                data: customDomain,
                headers: {
                    'Content-Type': 'application/json'
                },
                // since the API is not returning a JSON string,
                // override the default transformation (JSON.parse)
                transformResponse(data) {
                    if (data === 'success') {
                        return {
                            success: true
                        };
                    }
                    return {
                        success: false
                    };
                }
            });
        }

        function save(storeInformation, markTaskComplete) {
            return dataService.saveAll(settings.api.storeInformation, storeInformation)
                .then((response) => {
                    store = response;

                    if (store.completedLaunchRequirements) {
                        onboardingService.unlockTask('launch.launchStore');
                    }

                    if (store.launched) {
                        onboardingService.completeTask('launch.launchStore');
                        onboardingService.unlockTask('run.processOrder');
                    }

                    if (store.stripeAccountId) {
                        onboardingService.completeTask('launch.configureStore');
                    }

                    if ((store.logo && store.logo.imageLink) || markTaskComplete) {
                        const MILESTONE = 2;
                        return founderGuideService.completeFounderGuideTask('design.addLogo', null, MILESTONE)
                            .then(() => store);
                    }

                    return store;
                });
        }

        function removeImage(imageId) {
            var imageUrl = `${settings.api.images}/${imageId}`;
            return dataService.remove(imageUrl);
        }

        function getLaunchStatus() {
            return getStore(true).then(storeInfo => storeInfo.launched);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/storeInformation.service.js